<template>
  <div class="settings">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebarPromotion></layout-sidebarPromotion>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <div class="row">
            <div class="col-md-8 offset-md-2">
              <!-- Page Header -->
              <div class="page-header">
                <div class="row">
                  <div class="col-sm-12">
                    <h3 class="page-title">Message Settings</h3>
                  </div>
                </div>
              </div>
              <!-- /Page Header -->
              <!-- {{this.profileArr}} -->
              <form @submit.prevent="setupKey" class="was-validated">
                <div class="row">
                  <div class="col-sm-2">
                  </div>
                  <div class="col-sm-8">
                    <!-- {{memberSessionArr}} -->
                    <div v-if="isLoading"><i>
                        <center>Sedang diproses...</center>
                      </i></div>
                    <table class="table table-stripped">
                      <tr>
                        <th>Setting Auto Switch</th>
                        <td>
                          <div class="onoffswitch">
                            <input type="checkbox" :disabled="isLoading" name="onoffswitch" class="onoffswitch-checkbox"
                              @change="settingAutoSwitchSender()" v-model="dataParam.auto_switching_status"
                              id="auto_switching_status" />
                            <label class="onoffswitch-label" for="auto_switching_status">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </td>
                      </tr>
                    </table>

                    <div class="alert alert-warning">
                      Saat mengaktifkan Auto Switch Sender, maka akan berdampak pada fitur berikut:
                      <ul>
                        <li>Daftar Room Chat, Outbox, Inbox akan direset oleh sistem.</li>
                        <li>Sistem otomatis akan mengirim pesan menggunakan nomor yang sedang Online.</li>
                        <li>Room Chat akan di <i>merge</i> dengan lisensi lainnya (jika punya lebih dari 1 lisensi
                          aktif) </li>
                        <li>Akun otomatis logout dan perlu login ulang</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-sm-2">
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-2">
                  </div>
                  <div class="col-sm-8">
                    <!-- {{memberSessionArr}} -->
                    <div v-if="isLoading"><i>
                        <center>Sedang diproses...</center>
                      </i></div>
                    <table class="table table-stripped">
                      <tr>
                        <th>Allow Delete Message</th>
                        <td>
                          <div class="onoffswitch">
                            <input type="checkbox" :disabled="isLoading" name="onoffswitch" class="onoffswitch-checkbox"
                              @change="updateDeleteChatStatus()" v-model="dataParam.delete_chat_status"
                              id="delete_chat_status" />
                            <label class="onoffswitch-label" for="delete_chat_status">
                              <span class="onoffswitch-inner"></span>
                              <span class="onoffswitch-switch"></span>
                            </label>
                          </div>
                        </td>
                      </tr>
                    </table>

                  </div>
                  <div class="col-sm-2">
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>

<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebarPromotion from "@/components/layouts/SidebarPromotion.vue";
import { updateDeleteChatStatus } from "../../api/member";
export default {
  components: {
    LayoutHeader,
    LayoutSidebarPromotion
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASE_URL,
      isLoading: false,
      dataParam: {
        auto_switching_status: false,
        delete_chat_status: false,
      }
    };
  },
  computed: {
    memberSessionArr() {
      return this.$store.state.login.memberSession;
    }
  },
  created() {
    // console.log("this.member",this.memberSessionArr)
    if (this.memberSessionArr.auto_switching_status == 1) {
      this.dataParam.auto_switching_status = true
    } else {
      this.dataParam.auto_switching_status = false
    }

    if (this.memberSessionArr.delete_chat_status == 1) {
      this.dataParam.delete_chat_status = true
    } else {
      this.dataParam.delete_chat_status = false
    }
  },
  methods: {
    async updateDeleteChatStatus() {
      let newValue = this.dataParam.delete_chat_status;
      this.isLoading = await true;
      await this.$fire({
        title:
          "Apakah anda yakin akan melanjutkan aksi ini?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          var params = await {};
          if (this.dataParam.delete_chat_status == true) {
            params = await {
              delete_chat_status: 1
            };
          } else {
            params = await {
              delete_chat_status: 0
            };
          }
          await this.$store.dispatch("member/updateDeleteChatStatus", params)
            .catch(() => {
              this.dataParam.delete_chat_status = !newValue
            });
          await this.$store.dispatch('login/getProfile')

        } else {
          this.dataParam.delete_chat_status = !newValue
        }
      });

      this.isLoading = await false;

    },
    async settingAutoSwitchSender() {
      let newValue = this.dataParam.auto_switching_status;
      // console.log("vall", this.dataParam.auto_switching_status)
      this.isLoading = await true;
      await this.$fire({
        title:
          "Apakah anda yakin akan melanjutkan aksi ini?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          var params = await {};
          if (this.dataParam.auto_switching_status == true) {
            params = await {
              auto_switching_status: 1
            };
          } else {
            params = await {
              auto_switching_status: 0
            };
          }
          this.$store.dispatch("member/settingAutoSwitchSender", params).
            then(() => {
              this.$fire({
                title: "Info",
                text: "Change to Auto Switch Sender mode was successful, please log in again...",
                type: "success",
                timer: 3000
              }).then(async r => {
                this.isLoading = false;
                // await this.$router.push("/omni");
                window.location.href = this.baseUrl
              });
            })
            .catch(() => {
              this.isLoading = false;
              this.dataParam.auto_switching_status = !newValue
            });
        } else {
          this.dataParam.auto_switching_status = !newValue
          this.isLoading = false;
        }
      });

      // this.isLoading = await false;

    },
  },
  mounted() {
  },
  name: "settingsAutoSwitchSender"
};
</script>


// WEBPACK FOOTER //
// src/views/settings/autoSwitchSender.vue